import React from 'react';
import SolutionRentalInfoContainer from 'containers/SolutionRentalInfoContainer';

export default function SolutionRentalInfoPage() {
  return (
    <SolutionRentalInfoContainer />
  )
}
